<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 md:p-12 lg:flex-row"
>
  <div class="flex w-full flex-col gap-6 lg:w-3/5">
    <h2 class="text-3xl font-bold md:text-4xl">Sign up for the newsletter</h2>
    <p class="text-xl">
      Subscribe to our monthly newsletter to stay informed about the latest news
      and updates in the Capawesome, Capacitor, and Ionic ecosystems.
    </p>
  </div>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
    class="flex w-full flex-col justify-center gap-2 lg:w-2/5"
  >
    <div class="tui-form__row">
      <div tuiGroup>
        <div>
          <tui-textfield [style.border-radius]="'inherit'">
            <label tuiLabel>Email <span class="tui-required"></span></label>
            <input [formControl]="formGroup.controls.email" tuiTextfield />
          </tui-textfield>
          <tui-error
            formControlName="email"
            [error]="[] | tuiFieldError | async"
          />
        </div>
        <button
          tuiButton
          type="submit"
          [style.flex]="'0 0 auto'"
          [loading]="subscribeNewsletter.isPending()"
        >
          Subscribe
        </button>
      </div>
    </div>
    <div class="tui-form__row">
      <label tuiLabel class="flex items-center gap-2">
        <input
          formControlName="terms"
          tuiCheckbox
          type="checkbox"
          [size]="'m'"
        />
        <span class="tui-text_body-m">
          I've read and accept the
          <a
            href="https://capawesome.io/privacy/"
            target="_blank"
            class="text-[color:var(--tui-text-action)]"
            >Privacy Policy</a
          >. <span class="tui-required"></span>
        </span>
      </label>
      <tui-error
        formControlName="terms"
        [error]="[] | tuiFieldError | async"
      ></tui-error>
    </div>
  </form>
</section>
